<!--GPS定位报警-->
<template>
  <el-form class="pd-10" label-width="100px" :model="form">
    <ConfigBase :row-data="rowData" :sensor-config="sensorConfig"></ConfigBase>
    <el-form-item :label="$t('public.switch')" prop="gpsSwitch">
      <el-select v-model="form.gpsSwitch" v-if="isEdit">
        <el-option :label="$t('public.close')" :value="0"></el-option>
        <el-option :label="$t('public.open')" :value="1"></el-option>
      </el-select>
      <Modify
        v-else-if="jsonContent"
        :item="jsonContent.item.gps_enable"
        :mapper="openClose"
      ></Modify>
    </el-form-item>

    <el-form-item :label="$t('public.command')" v-if="rowData">
      <div>
        {{ jsonContent.cmd }}
      </div>
      <div style="position: absolute;top: 0;right: 0">
        <el-button @click="isEdit = false" v-if="isEdit">
          {{ $t('public.cancel') }}
        </el-button>

        <el-button type="primary" v-if="!isEdit" @click="isEdit = true">
          {{ $t('public.config') }}
        </el-button>
        <el-button type="primary" @click="confirm" v-if="isEdit"
          >{{ 'public.btn_confirm' }}
        </el-button>
      </div>
    </el-form-item>

    <el-divider v-if="rowData"></el-divider>
    <ConfigList :sensor-info="rowData" :list="configList"></ConfigList>
  </el-form>
</template>

<script>
import { alarm, openClose } from '@/utils/convert'
import { sensorGetDetailConfig, updateGPSConfig } from '@/api/modules/sensor'
import {
  transformEditSensorConfig,
  transformViewSensorConfig
} from '@/utils/transform/sensorTransForm'
import Modify from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/component/Modify.vue'
import ConfigBase from '@/pages/equipment/sensor/components/sensor/cionfig/ConfigBase.vue'
import ConfigList from '@/pages/equipment/sensor/components/sensor/cionfig/children/ConfigList.vue'

export default {
  components: {
    ConfigList,
    ConfigBase,
    Modify
  },
  props: {
    rowData: {}
  },
  computed: {
    openClose () {
      return openClose
    },
    alarm () {
      return alarm
    }
  },
  data () {
    return {
      form: {
        gpsSwitch: 1
      },

      isEdit: false,
      jsonContent: {
        item: {}
      },
      configList: [],
      sensorConfig: null
    }
  },
  methods: {
    getConfig () {
      // eslint-disable-next-line camelcase
      const { id, tag_id } = this.rowData
      sensorGetDetailConfig(
        {
          sensorId: id,
          tagId: tag_id
        },
        'gps'
      ).then(({ result }) => {
        if (result.sensorConfig) {
          this.sensorConfig = result.sensorConfig

          this.jsonContent = JSON.parse(this.sensorConfig.content)
          this.configList = this.sensorConfig.responseDeviceConfigLogList
          if (this.sensorConfig) {
            this.$emit('onConfigStatusChange', this.sensorConfig.status)
          }
        } else {
          this.jsonContent = transformViewSensorConfig(this.form)
          if (this.jsonContent.item.gps_switch) {
            // 重命名
            this.jsonContent.item.gps_enable = this.jsonContent.item.gps_switch
          }
        }
      })
    },
    confirm () {
      this.form.idList = [this.rowData.id]
      this.form.type = this.rowData.type
      updateGPSConfig(this.form).then(({ result }) => {
        if (result) {
          this.$message.success('保存成功')
          this.isEdit = false

          this.getConfig()
        }
      })
    },
    // 给外部调用
    setData (config) {
      this.jsonContent.item = config
      this.form = { ...this.form, ...transformEditSensorConfig(config) }
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>
